import hoverManager from './hoverManager.js';
import filterFeaturesOnMap from '../../functions/map/cardFilter';
import { handleFeaturesPaint } from './paintManager.js';
import { handleFeaturesVisibility } from '../cardsGroupsFeatures.js';
import { handleAxlesVisibility } from './axlesManager.js';
import { handleFeaturesOpacity } from './opacityManager.js';
import { removeFeaturesHighlight, 
        updateFeaturesOnMapAndFitCamera, 
        updateMapLevelImage } from './mapFunctions.js';

export default function mapManager(map, props, prevProps) {

    if (!props.loadedMap) return;

    if (props.loadingLevel !== prevProps.loadingLevel || props.refreshSwitch !== prevProps.refreshSwitch) {
        hoverManager(map, props.loadingLevel || props.refreshSwitch);
    }

    if (props.featuresGroups !== prevProps.featuresGroups || props.loadedMap !== prevProps.loadedMap) {
        updateFeaturesOnMapAndFitCamera(map, props.featuresGroups);
    }
    
    if (props.filters.levelIds !== prevProps.filters.levelIds
        || props.filters.stageIds !== prevProps.filters.stageIds) {
        updateMapLevelImage(map, props.filters.stageIds, props.filters.levelIds, props.projectData);
    }     

    if (props.loadedMap !== prevProps.loadedMap
        || props.featuresGroups !== prevProps.featuresGroups
        || props.loadedLevels !== prevProps.loadedLevels
        || props.filters.status !== prevProps.filters.status
        || props.filters.stageIds !== prevProps.filters.stageIds
        || props.filters.levelIds !== prevProps.filters.levelIds
        || props.filters.cardCategoryIds !== prevProps.filters.cardCategoryIds
        || props.filters.protocolIds !== prevProps.filters.protocolIds
        || props.filters.appartmentIds !== prevProps.filters.appartmentIds
        || props.filters.customcardId !== prevProps.filters.customcardId
        || props.filters.cardsGroupIds !== prevProps.filters.cardsGroupIds
        || props.filters.zoneIds !== prevProps.filters.zoneIds
        || props.filters.volume !== prevProps.filters.volume
        || props.filters.area !== prevProps.filters.area
        || props.filters.surface !== prevProps.filters.surface
        || props.filters.height !== prevProps.filters.height
        || props.filters.bimElements !== prevProps.filters.bimElements
        || props.filters.isDelayed !== prevProps.filters.isDelayed
        || props.paint !== prevProps.paint
        || props.day !== prevProps.day
        || props.fullBuilding !== prevProps.fullBuilding
        || props.timeline !== prevProps.timeline
        || props.plannedTimeline !== prevProps.plannedTimeline
        || props.timelineSelect !== prevProps.timelineSelect) {
            
        map.cardsGroupsData = props.projectData.cards_groups;
        map.figuregroups_map = props.projectData.figuregroups_map;
        map.filters = {
            ...props.filters,
            timeline: props.timeline,
            plannedTimeline: props.plannedTimeline,
            day: props.day,
        }
        const [featureIds, visibleCardsGroupIds] = handleFeaturesVisibility(map, props);
        filterFeaturesOnMap(map, featureIds);
        props.visibleCardsGroupsChange(visibleCardsGroupIds);
        handleFeaturesPaint(map, props, props.paint);
    }

    if (props.axles !== prevProps.axles) {
        handleAxlesVisibility(map, props.axles);
    }

    if (props.opacity !== prevProps.opacity) {
        handleFeaturesOpacity(map, props.opacity);
    }

    if (props.roadLabel !== prevProps.roadLabel) {
        const visibility = props.roadLabel ? 'visible' : 'none';
        map.setLayoutProperty('road-label', 'visibility', visibility);
    }

    if (props.popUpMenu !== prevProps.popUpMenu && !props.popUpMenu.show) {
        removeFeaturesHighlight(map);
    }
}